module.exports = __webpack_public_path__ + "static/worldData-d82553aacea8c604f76f927b75c01171.jpg";